export const isJSON = (str: string) => {
  if (typeof str !== "string") return false;
  try {
    const result = JSON.parse(str);
    return result && (typeof result === "object" || Array.isArray(result));
  } catch (e) {
    return false;
  }
};
